export default "__VITE_ASSET__lVJ8uKEe__"